import React from "react";
import { getItem }   from '../Storage';
import { Routes }    from '../navigation';
import { StyleUtils } from '../utils';
import '../css/salient.css';

export default class Header extends React.Component {

  render() {
    if (this.props.hide) {
      return null;
    }

    let partner   = getItem('partner');
    let title     = this.props.title;
    let subtitle  = this.props.subtitle;
    let logo_url  = partner && partner.logo_url ? partner.logo_url : 'https://teletailstest.s3.amazonaws.com/profile/1633529478005.png';

    let is_home_enabled = partner && partner.enable_home_screen ? partner.enable_home_screen : false;
    let display_home    = this.props.display_home_button === true ? true : false;
        display_home    = is_home_enabled && display_home ? true : display_home;

    let go_home = () => {
      let partner_code = partner && partner.code ? partner.code : '';
      this.props.navigate(Routes.HOME + partner_code);
    }

    // The round icon either steps back inside a screen (on_back) or returns to the home screen
    // (display_home_icon), so mid-flow screens keep the same control the care-selection step shows.
    let round_action = this.props.on_back ? this.props.on_back : null;
        round_action = !round_action && this.props.display_home_icon === true && this.props.navigate ? go_home : round_action;

    let root_style = {
      '--ch-accent':      StyleUtils.get_header_color(),
      '--ch-grad-start':  StyleUtils.get_header_gradient_start(),
      '--ch-grad-end':    StyleUtils.get_header_gradient_end(),
      '--ch-accent-text': StyleUtils.get_header_text_color_auto(),
      '--ch-button':      StyleUtils.get_button_color(),
      '--ch-button-text': StyleUtils.get_button_text_color_auto(),
      '--ch-primary':     StyleUtils.get_primary_color(),
    };

    let hero_class = StyleUtils.get_hero_class('sln-hero' + (this.props.flush === true ? ' sln-hero--flush' : ''));
    let chip_class = StyleUtils.get_logo_chip_class('sln-hero-logo-chip');

    return <div className={ hero_class } style={root_style}>
      <div className='sln-hero-top'>
        <div className={ chip_class }>
          <img className='sln-hero-logo' src={ logo_url } alt='' />
        </div>
        { display_home ? <div className='sln-hero-home sln-pressable' onClick={ go_home }>
                           <span className='fas fa-home' />
                           <span>Home</span>
                         </div>
          : ( round_action ? <div className='sln-hero-homebtn sln-pressable' onClick={ round_action }>
                               <span className='fas fa-home' />
                             </div> : null ) }
      </div>
      { (title || subtitle) ? <div className='sln-hero-greeting'>
          { title ? <span className='sln-hero-title'>{ title }</span> : null }
          { subtitle ? <span className='sln-hero-subtitle'>{ subtitle }</span> : null }
        </div> : null }
    </div>
  }
}
